module.exports = __webpack_public_path__ + "media/images/category/food-drinks-0fc18237da0eba79a31e47f050eeff7e.svg";